import {
  useHistory
} from 'react-router-dom'

const UnAuthorizedPage = ({ isBack = true } : { isBack? : boolean}) => {
  const history = useHistory()
  return <div className="flex flex-col text-center">
    <h3 className="p-4">คุณไม่ได้รับอนุญาติเข้าถึงหน้านี้</h3>
    {isBack ?<h6 className="p-4">กดปุ่มด้านล่างเพื่อกลับสู่หน้าหลัก</h6> : null}
    {isBack ? <div className="flex justify-center">
      <button className='btn-secondary' onClick={() => history.push('/')}>หน้าหลัก</button>
    </div> : null}
  </div>
}

export default UnAuthorizedPage